// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"b7d3b0c7","268":"6c9ea170","285":"6f7581a4"}[chunkId] + ".chunk.js";
};